import {
    DisabledSubTitle,
    DisabledTitle,
} from "app/pages/digital-suite/home-page/components/Rewards/screens/MainScreen/sections/RewardsSection/Card/Card.styled";
import type { IPackage } from "app/pages/digital-suite/home-page/components/Rewards/utils/types";
import { i18nFilter } from "app/filters/i18nFilter";

interface IDisabledCardProps {
    cardItem: IPackage;
}

const DisabledCard = ({ cardItem }: IDisabledCardProps) => {
    const i18n = i18nFilter();

    return (
        <>
            <DisabledTitle>{`${cardItem.DiscountPercentage}%`}</DisabledTitle>
            <DisabledSubTitle>
                {i18n("rewards_modal.main_screen.rewards_section.disabled_card.subtitle")}
            </DisabledSubTitle>
        </>
    );
};

export default DisabledCard;
